export function getSelectionTitleVariantStyles(marketDisplayName, type) {
    return {
        $extendFromVariant: `${type}SelectionCardTitle`,
        root: {
            flex: "1 1 auto",
            marginBottom: marketDisplayName ? undefined : "$s1",
        }
    };
}
//# sourceMappingURL=getSelectionTitleVariantStyles.js.map